module.exports = __webpack_public_path__ + "static/img/pic200-7.5dbf2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic200-7.png
// module id = 7IYm
// module chunks = 30